import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 144px)',
      overflowY: 'auto',
      '& .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense': {
        width: '36vw',
      },
    },
    saveButton: {
      fontWeight: 700,
      color: '#2AAB3F',
    },
    card: {
      padding: '16px 16px 16px 16px',
      overflowY: 'hidden',
      marginTop: 1,
      marginBottom: 1,
    },
    radio: {
      display: 'inline-flex',
      marginTop: '16px',
      color: 'rgba(255,255,255,0.87)',
    },
    grid: {
      padding: '16px 16px 16px 16px',
      overflowY: 'hidden',
      borderRadius: '10px 10px 10px 10px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      marginBottom: '16px',
    },
    grids: {
      padding: '16px 16px 16px 16px',
      overflowY: 'hidden',
      borderRadius: '10px 10px 1px 1px',
      marginBottom: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    gridSubStep: {
      padding: '16px 16px 16px 0px',
      marginBottom: 1,
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    formControl: {
      width: '100%',
      flexFlow: 'wrap',
    },
    PMheaderGrid: {
      '& .PMheader': {
        fontSize: '30px',
        fontWeight: 300,
      },
      '& .PMsubtitle': {
        fontSize: '14px',
        fontWeight: 600,
        color: '#707070',
        fontStyle: 'normal',
        lineHeight: '20px',
      },
    },
    stepGrid: {
      display: 'flex',
      '& .step': {
        fontSize: '16px',
        fontWeight: 400,
        fontFamily: 'inherit',
        lineHeight: '20px',
        marginLeft: '13px',
      },
      '& .stepVertical': {
        fontSize: '16px',
        fontWeight: 400,
        fontFamily: 'inherit',
        lineHeight: '20px',
        marginLeft: '-3px',
      },
    },
    preTag: {
      fontSize: '16px',
      whiteSpace: 'break-spaces',
      margin: '0px',
      fontWeight: 400,
      textAlign: 'left',
      fontFamily: 'inherit',
      letterSpacing: '0.5px',
      fontStyle: 'normal',
      fontFeatureSettings: `'tnum' on, 'lnum' on`,
      color: 'rgba(255, 255, 255, 0.87)',
    },
    radioStyle: {
      display: 'inline-flex',
      marginTop: '-26px',
      '& .radioComplete': {
        marginTop: '9px ',
        fontSize: '16px ',
        fontWeight: 400,
      },
      '& .radioCompleteMarginRight': {
        marginRight: '70px',
      },
    },
    commentGrid: {
      paddingLeft: '16px',
      justifyContent: 'flex-end',
    },
    commentSubStep: {
      paddingLeft: '26px',
      justifyContent: 'flex-end',
    },
    comment: {
      paddingBottom: '5px',
    },
    textField: {
      backgroundColor: '#1a1a1a',
      height: '100px',
      width: '36vw',
      borderRadius: '4px',
      border: '1px solid rgba(179, 179, 179, 0.87)',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0.5px',
      marginRight: '16px',
    },
    pmChecklistSaveButtonGrid: {
      paddingRight: '10px',
    },
    childrenContainer: {
      marginBottom: '16px',
    },
    addDeficiencyButtonGrid: {
      '& .submitInspectionText': {
        fontWeight: 700,
        color: MaterialPalette.common.black,
        letterSpacing: '0.5px',
        marginLeft: '8px',
      },
    },
  }),
);

export default useStyles;
